import { SxProps, Theme } from '@mui/material';

export const titleSX: SxProps = {
	fontSize: 'var(--font-size-default)',
	fontWeight: 'bold',
	textTransform: 'uppercase',
};

export const linkSX: SxProps<Theme> = (theme) => ({
	fontSize: 'var(--font-size-default)',
	'&:hover': {
		color: theme.palette.primary.main,
	},
});
